module.exports = __webpack_public_path__ + "assets/fonts/add.9d039b78.svg";